import { NgModule } from '@angular/core';
import { PipesModule } from './pipes/pipes.module';
import { LineChartModule } from './components/line-chart/line-chart.module';
import { GraphTreeModule } from './components/graph-tree/graph-tree.module';
import { IndicatorChartModule } from './components/indicator-chart/indicator-chart.module';
import { LogoutTipModule } from './components/logout-tip/logout-tip.module';
import { SmallPanelModule } from './components/small-panel/small-panel.module';
import { ThreeModule } from './components/three/three.module';
import { TaskBatchModule } from './components/task-batch/task-batch.module';

@NgModule({
    exports: [
        LineChartModule,
        GraphTreeModule,
        IndicatorChartModule,
        PipesModule,
        LogoutTipModule,
        SmallPanelModule,
        ThreeModule,
        TaskBatchModule,
    ],
})
export class DMCommonModule { }
